import { shadowStyle } from '@usepepper/sprout-kit-ui';

export const MAP_HEIGHT = 240;

export const REGION_DELTA = 0.003;

export const MARKER_ANCHOR = { x: 0.5, y: 0.5 } as const;

export const PIN_MARKER_ANCHOR = { x: 0.5, y: 1 } as const;

/** Edge length of the square map next to the account name and address. */
export const MAP_COMPACT_SIZE = 88;

export const MARKER_SIZE = 24;

const ASPECT_RATIO = 21 / 16;

export const MARKER_ICON_HEIGHT = MARKER_SIZE * ASPECT_RATIO;

export const DOT_MARKER_SIZE = 10;
export const DOT_MARKER_BORDER_WIDTH = 3;
export const DOT_MARKER_OUTER_SIZE =
  DOT_MARKER_SIZE + DOT_MARKER_BORDER_WIDTH * 2;

export const DOT_MARKER_SHADOW_OFFSET = { height: 2, width: 0 };
export const DOT_MARKER_SHADOW_OPACITY = 0.3;
export const DOT_MARKER_SHADOW_RADIUS = 6;

export const LABEL_SHADOW = shadowStyle('soft0', 2);
